import {FC, PropsWithChildren, useMemo} from "react";
import {useFile} from "@hooks/filesHooks";
import {injectChild} from "@constructor/functions";
import {useSupportMessageContext} from "@constructor/components/features/support/context";
import {AttachmentType} from "@interfaces/user/support";

interface MessageAttachmentProps {
    attachment_file_id: string;
}

interface MessageAttachmentChildProps {
    attachment_loading: boolean;
    attachment_url: string;
    attachment_file_name: string;
    attachment_type: number;
}

const MessageAttachment: FC<PropsWithChildren<MessageAttachmentProps>> = ({attachment_file_id, children}) => {

    const file = useFile(attachment_file_id);
    const message = useSupportMessageContext();
    
    const attachment = message?.attachments?.find(att => att.fileId === attachment_file_id);

    const data: MessageAttachmentChildProps = useMemo<MessageAttachmentChildProps>(() => ({
        attachment_loading: file?.loading || true,
        attachment_url: file?.data?.url || '',
        attachment_file_name: file?.data?.fileName || '',
        attachment_type: typeToNumber(attachment?.type)
    }), [file?.loading, file?.data?.url, file?.data?.fileName, attachment?.type]);

    return injectChild(data, children);
}

function typeToNumber(type?: AttachmentType): number {
    switch (type) {
        case AttachmentType.Null:
            return 0;
        case AttachmentType.Image:
            return 1;
        case AttachmentType.Video:
            return 2;
        case AttachmentType.File:
            return 3;
        default:
            return 0;
    }
}

export default MessageAttachment;